import {Tab as UITab, type TabProps} from "@headlessui/react";
import clsx from "clsx";

export const Tab: React.FC<TabProps> = ({children, className, disabled, ...rest}) => {
  return (
    <UITab
      className={({selected}) =>
        clsx(
          "px-4 py-1 text-sm font-light rounded-full focus:outline-none border whitespace-nowrap",
          selected
            ? "bg-primary text-white border-primary"
            : "bg-background text-blackout border-stroke",
          disabled && "opacity-50",
          className,
        )
      }
      disabled={disabled}
      {...rest}
    >
      {children}
    </UITab>
  );
};
